import { render, staticRenderFns } from "./ParkingRestrictions.vue?vue&type=template&id=581b60af&scoped=true"
import script from "./ParkingRestrictions.vue?vue&type=script&lang=js"
export * from "./ParkingRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b60af",
  null
  
)

export default component.exports